import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { ThousandsNOKPipe } from './pipes/thousands-NOK.pipe';
import { NumberIteratorPipe } from './pipes/number-iterator.pipe';
import { NamesWithDashPipe } from './pipes/names-with-dash.pipe';
import { UserWithoutNamePipe } from './pipes/user-without-name.pipe';
import { PaginationPagesPipe } from './pipes/pagination-pages.pipe';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ResultsPerPageComponent } from './components/results-per-page/results-per-page.component';
import { ToggleAllCheckboxesComponent } from './components/toggle-all-checkboxes/toggle-all-checkboxes.component';
import { ModalDirective } from './directives/modal.directive';
import { ErrorModalComponent } from './components/modals/error-modal/error-modal.component';
import { EditAnswerModalComponent } from './components/modals/edit-answer-modal/edit-answer-modal.component';
import { ConfirmationModalComponent } from './components/modals/confirmation-modal/confirmation-modal.component';
import { DetailViewAnalysesComponent } from './components/detail-views/detail-view-analyses/detail-view-analyses.component';
import { DetailViewQuestionsComponent } from './components/detail-views/detail-view-questions/detail-view-questions.component';
import { DetailViewKycComponent } from './components/detail-views/detail-view-kyc/detail-view-kyc.component';
import { DetailViewInvestmentsComponent } from './components/detail-views/detail-view-investments/detail-view-investments.component';
import { AdminFilesHandlerComponent } from './components/admin-files-handler/admin-files-handler.component';
import { DetailViewAdminFilesComponent } from './components/detail-views/detail-view-admin-files/detail-view-admin-files.component';
import { FullTextModalComponent } from './components/modals/full-text-modal/full-text-modal.component';
import { SearchComponent } from './components/search/search.component';
import { SearchWithoutDebounceComponent } from './components/search-without-debounce/search-without-debounce.component';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { FullTextDirective } from './directives/full-text.directive';
import { DetailViewPepDataComponent } from './components/detail-views/detail-view-pep-data/detail-view-pep-data.component';
import { StatusSwitcherComponent } from './components/status-switcher/status-switcher.component';
import { ItemSelectorComponent } from './components/item-selector/item-selector.component';
import { NoResultsComponent } from './components/no-results/no-results.component';
import { SelectedItemsComponent } from './components/selected-items/selected-items.component';
import { AdvancedOptionsSwitcherComponent } from './components/advanced-options-switcher/advanced-options-switcher.component';
import { ResetFiltersButtonComponent } from './components/reset-filters-button/reset-filters-button.component';
import { DownloadFileComponent } from './components/download-file/download-file.component';
import { SelfPublishStatusPipe } from './pipes/self-publish-status.pipe';
import { InvestorPipe } from './pipes/investor.pipe';
import { FileValueAccessorDirective } from './directives/file-value-accessor.directive';
import { FileValidatorDirective } from './directives/file-validator.directive';
import { OfferTypePipe } from './pipes/offer-type.pipe';
import { FilePreviewModalComponent } from './components/modals/file-preview-modal/file-preview-modal.component';
import { ShortFileNamePipe } from './pipes/short-file-name.pipe';
import { SortableHeaderComponent } from './components/sortable-header/sortable-header.component';
// eslint-disable-next-line max-len
import { DetailViewRepresentativesComponent } from './components/detail-views/detail-view-representatives/detail-view-representatives.component';
import { LocalPaginationComponent } from './components/local-pagination/local-pagination.component';
import { AddManualPepCheckComponent } from './components/modals/add-manual-pep-check/add-manual-pep-check.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, RouterModule, FormsModule, ReactiveFormsModule],
  declarations: [
    PhoneNumberPipe,
    ThousandsNOKPipe,
    NumberIteratorPipe,
    NamesWithDashPipe,
    UserWithoutNamePipe,
    PaginationPagesPipe,
    PaginationComponent,
    ResultsPerPageComponent,
    ToggleAllCheckboxesComponent,
    ModalDirective,
    FullTextModalComponent,
    ErrorModalComponent,
    EditAnswerModalComponent,
    ConfirmationModalComponent,
    DetailViewAnalysesComponent,
    DetailViewQuestionsComponent,
    DetailViewKycComponent,
    DetailViewInvestmentsComponent,
    AdminFilesHandlerComponent,
    DetailViewAdminFilesComponent,
    SearchComponent,
    SearchWithoutDebounceComponent,
    DragAndDropDirective,
    FullTextDirective,
    DragAndDropDirective,
    DetailViewPepDataComponent,
    StatusSwitcherComponent,
    ItemSelectorComponent,
    NoResultsComponent,
    SelectedItemsComponent,
    AdvancedOptionsSwitcherComponent,
    ResetFiltersButtonComponent,
    DownloadFileComponent,
    SelfPublishStatusPipe,
    InvestorPipe,
    FileValueAccessorDirective,
    FileValidatorDirective,
    OfferTypePipe,
    DetailViewRepresentativesComponent,
    FilePreviewModalComponent,
    ShortFileNamePipe,
    SortableHeaderComponent,
    LocalPaginationComponent,
    AddManualPepCheckComponent
  ],
  exports: [
    ReactiveFormsModule,
    PhoneNumberPipe,
    ThousandsNOKPipe,
    NumberIteratorPipe,
    NamesWithDashPipe,
    UserWithoutNamePipe,
    PaginationPagesPipe,
    PaginationComponent,
    ResultsPerPageComponent,
    ToggleAllCheckboxesComponent,
    ModalDirective,
    DetailViewAnalysesComponent,
    DetailViewQuestionsComponent,
    DetailViewKycComponent,
    DetailViewInvestmentsComponent,
    AdminFilesHandlerComponent,
    DetailViewAdminFilesComponent,
    SearchComponent,
    SearchWithoutDebounceComponent,
    DragAndDropDirective,
    FullTextDirective,
    DragAndDropDirective,
    DetailViewPepDataComponent,
    StatusSwitcherComponent,
    ItemSelectorComponent,
    NoResultsComponent,
    SelectedItemsComponent,
    AdvancedOptionsSwitcherComponent,
    ResetFiltersButtonComponent,
    DownloadFileComponent,
    SelfPublishStatusPipe,
    InvestorPipe,
    FileValueAccessorDirective,
    FileValidatorDirective,
    OfferTypePipe,
    DetailViewRepresentativesComponent,
    FilePreviewModalComponent,
    ShortFileNamePipe,
    SortableHeaderComponent,
    LocalPaginationComponent
  ]
})
export class SharedModule {}
